import { type AppState } from 'src/redux/app/app.store'

export const selectCurrentRepairVehicle = (state: AppState) => state.repairManagement.currentRepairVehicle
export const selectCurrentRepairAccount = (state: AppState) => state.repairManagement.currentRepairAccount
export const selectRepairIssues = (state: AppState) => state.repairManagement.repairIssues
export const selectRepairSpareParts = (state: AppState) => state.repairManagement.spareParts
